import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { createSelectable } from "react-selectable";
import fetch from "../shared/Fetch";
import imgUrl from "../trash.svg";
import { getFirstDateOfWeek } from "../shared/TimeUtil";

const ModalBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
`;

const ConfirmModal = styled.div`
  position: fixed;
  top: 25vh;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1001;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  padding: 1rem 1.25rem;
  width: min(32rem, 90vw);
`;

const ConfirmTitle = styled.h3`
  margin: 0 0 0.5rem 0;
`;

const ConfirmMessage = styled.p`
  margin: 0 0 1rem 0;
`;

const ConfirmActions = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
`;

const ConfirmButton = styled.button`
  padding: 0.4rem 0.8rem;
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  background: ${props => (props.destructive ? "var(--color-red)" : "#eee")};
  color: ${props => (props.destructive ? "#fff" : "#000")};
`;

const StyledStaffingRow = styled.tr`
  > td input {
    text-align: right;
    height: 1.5rem;
  }
  &:nth-child(2n) {
    background: var(--table-band-background);
  }
  &:hover {
    background: var(--table-hover-background);
  }
`;

/* const VacationRow = styled.td`
  padding-right: 0.9rem;
  font-size: 0.8rem;
  text-align: right;
  > label {
  }
`; */

const LeadingValue = styled.td`
  padding: 0.3rem;
  width: 5%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 1rem;

  @media (max-width: 900px) {
    width: 20%;
  }

  @media (max-width: 750px) {
    padding: 0;
    a {
      font-size: 0.7rem;
    }
  }
`;

const WeekDataStyled = styled.td`
  white-space: nowrap;
  text-align: right;
  position: relative;

  --accent: ${props =>
    props.vacation ? "var(--table-vacation)" : "transparent"};
  visibility: ${props => (props.quitOrBeforeStart ? "hidden" : "visible")};

  &:after {
    border-bottom: 15px solid var(--accent, transparent);
    border-left: 15px solid transparent;
    bottom: 0;
    content: "";
    display: block;
    height: 0;
    position: absolute;
    right: 0;
    width: 0;
  }

  &:hover {
    outline: 1px solid var(--color-black);
  }

  @media (max-width: 750px) {
    input {
      font-size: 0.7rem;
    }
  }
`;

const IconImage = styled.td`
  text-align: center;
  img {
    width: 0.8rem;
    cursor: pointer;
  }
`;

class WeekData extends React.Component {
  render() {
    return (
      <WeekDataStyled
        vacation={this.props.vacation}
        quitOrBeforeStart={this.props.quitOrBeforeStart}
      >
        <input
          type="number"
          onBlur={this.props.onBlur}
          data-yearweek={this.props.yearweek}
          value={this.props.value}
          name={this.props.yearWeek}
          autoFocus={this.props.setFocus}
          onChange={this.props.onChange}
          className="weekData__input"
          min="0"
          step={this.props.fullDayHours}
        />
      </WeekDataStyled>
    );
  }
}

const SelectableWeekData = createSelectable(WeekData);

var vacWeeks = [];

class StaffingRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      valueUpdated: false,
      departments: this.props.departments,
      groups: this.props.groups,
      data: this.props.data,
      seniorities: this.props.seniorities,
      serviceareas: this.props.serviceareas || "all",
      showConfirm: false
    };
    this.updateStaffing = this.updateStaffing.bind(this);
    this.deleteStaffing = this.deleteStaffing.bind(this);
    this.openConfirm = this.openConfirm.bind(this);
    this.closeConfirm = this.closeConfirm.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    if (props.data !== state.data) {
      return {
        ...state,
        data: props.data
      };
    }
    return null;
  }

  updateStaffing(e) {
    if (this.state.valueUpdated) {
      this.props.sumbitStaffing(
        e.target.value,
        this.props.consultantId,
        this.props.engagementId,
        e.target.dataset.yearweek
      );
      this.setState({ valueUpdated: false });
      this.props.updateWeekSum();
    }
  }

  updateInputValue(index, e) {
    const data = this.state.data;
    data.staffing[index].hours = e.target.value;
    this.setState({ data: data, valueUpdated: true });
  }

  openConfirm() {
    this.setState({ showConfirm: true });
  }

  closeConfirm() {
    this.setState({ showConfirm: false });
  }

  deleteStaffing() {
    fetch("/staffings", {
      method: "DELETE",
      body: JSON.stringify({
        consultantId: this.props.consultantId,
        engagementId: this.props.engagementId
      })
    }).then(
      response => {
        this.setState({ showConfirm: false });
        this.props.onDelete(this.props.consultantId, this.props.engagementId);
      },
      reason => {
        console.log(
          "Something went wrong while performing the request",
          reason
        );
      }
    );
  }

  render() {
    const { departments, groups, seniorities, serviceareas } = this.state;
    const endDate = this.props.endDate;
    const startDate = this.props.startDate;
    const totalHours = this.props.totalHours;

    return (
      <StyledStaffingRow
        className={
          this.props.engagementStatus.toLowerCase() === "tilbud"
            ? "engagementRow__offerRow"
            : this.props.vacation
            ? "engagementRow_vacation"
            : this.props.plannedAbsence
            ? "engagementRow_plannedAbsence"
            : ""
        }
      >
        {this.props.leadingValues.map((leadingValue, i) => (
          <LeadingValue key={i}>
            <Link
              to={
                "/" +
                departments +
                "/" +
                groups +
                "/" +
                seniorities +
                "/" +
                serviceareas +
                "/" +
                leadingValue.link +
                "/" +
                this.props.weeks +
                "/" +
                this.props.offset +
                "/" +
                this.props.availableOnly
              }
            >
              {leadingValue.value}
            </Link>
          </LeadingValue>
        ))}
        <IconImage>
          {this.props.vacation ? null : (
            <img
              src={imgUrl}
              alt="Slett"
              title={this.props.deleteTooltip || "Slett rad"}
              onClick={this.openConfirm}
            />
          )}
        </IconImage>

        {this.state.showConfirm && (
          <>
            <ModalBackdrop onClick={this.closeConfirm} />
            <ConfirmModal onClick={e => e.stopPropagation()}>
              <ConfirmTitle>
                {this.props.confirmTitle || "Bekreft sletting"}
              </ConfirmTitle>
              <ConfirmMessage>
                {this.props.confirmMessage ||
                  "Er du sikker på at du vil slette denne raden? Dette kan ikke angres."}
              </ConfirmMessage>
              <ConfirmActions>
                <ConfirmButton onClick={this.closeConfirm}>
                  {this.props.confirmCancelLabel || "Avbryt"}
                </ConfirmButton>
                <ConfirmButton destructive onClick={this.deleteStaffing}>
                  {this.props.confirmConfirmLabel || "Slett"}
                </ConfirmButton>
              </ConfirmActions>
            </ConfirmModal>
          </>
        )}

        {this.state.data.staffing.map((week, i) => {
          if (this.props.holiday) {
            if (this.props.vacation && week.hours > 0) {
              vacWeeks.push(week.yearWeek);
              return (
                <SelectableWeekData
                  key={i}
                  selectableKey={{
                    engagementIndex: this.props.engagementIndex,
                    consultantIndex: this.props.consultantIndex,
                    weekIndex: i
                  }}
                  quitOrBeforeStart={
                    (endDate &&
                      new Date(endDate) < getFirstDateOfWeek(week.yearWeek)) ||
                    (startDate &&
                      new Date(startDate) > getFirstDateOfWeek(week.yearWeek))
                  }
                  onBlur={this.updateStaffing}
                  yearweek={week.yearWeek}
                  value={week.hours}
                  setFocus={this.props.setFocus && i === 0}
                  onChange={this.updateInputValue.bind(this, i)}
                  holiday={this.props.holiday}
                  engagementId={this.props.engagementId}
                />
              );
            } else if (!this.props.vacation) {
              for (let j = 0; j < vacWeeks.length; j++) {
                if (week.yearWeek === vacWeeks[j]) {
                  return (
                    <SelectableWeekData
                      key={i}
                      selectableKey={{
                        engagementIndex: this.props.engagementIndex,
                        consultantIndex: this.props.consultantIndex,
                        weekIndex: i
                      }}
                      quitOrBeforeStart={
                        (endDate &&
                          new Date(endDate) <
                            getFirstDateOfWeek(week.yearWeek)) ||
                        (startDate &&
                          new Date(startDate) >
                            getFirstDateOfWeek(week.yearWeek))
                      }
                      onBlur={this.updateStaffing}
                      fullDayHours={this.props.fullDayHours}
                      yearweek={week.yearWeek}
                      value={week.hours}
                      setFocus={this.props.setFocus && i === 0}
                      onChange={this.updateInputValue.bind(this, i)}
                      holiday={this.props.holiday}
                      engagementId={this.props.engagementId}
                    />
                  );
                }
              }
            }
            return null;
          } /* else if (this.props.vacation) {
            return (
              <VacationRow key={i}>
                <label>{week.hours}</label>
              </VacationRow>
            );
          }*/

          return (
            <SelectableWeekData
              key={i}
              selectableKey={{
                engagementIndex: this.props.engagementIndex,
                consultantIndex: this.props.consultantIndex,
                weekIndex: i
              }}
              quitOrBeforeStart={
                (endDate &&
                  new Date(endDate) < getFirstDateOfWeek(week.yearWeek)) ||
                (startDate &&
                  new Date(startDate) > getFirstDateOfWeek(week.yearWeek))
              }
              onBlur={this.updateStaffing}
              yearweek={week.yearWeek}
              value={week.hours}
              fullDayHours={this.props.fullDayHours}
              setFocus={this.props.setFocus && i === 0}
              onChange={this.updateInputValue.bind(this, i)}
              holiday={this.props.holiday}
              engagementId={this.props.engagementId}
            />
          );
        })}
        <WeekDataStyled>{totalHours}</WeekDataStyled>
      </StyledStaffingRow>
    );
  }
}

export default StaffingRow;
